import { render, staticRenderFns } from "./RaidsList.vue?vue&type=template&id=8f90a262&scoped=true&"
import script from "./RaidsList.vue?vue&type=script&lang=js&"
export * from "./RaidsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f90a262",
  null
  
)

export default component.exports